import React, { useState } from "react";
import {
    BarChart,
    Bar,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    Legend,
    ResponsiveContainer,
} from "recharts";

const PatientsBySpeciality = ({ specialityData, doctorList, selectedDoctor, setSelectedDoctor }) => {
    const [selectedCategory, setSelectedCategory] = useState("All"); // Default is All

    const handleCategoryClick = (category) => {
        setSelectedCategory(category);
    };

    return (
        <div className="bg-white rounded-xl shadow p-6 flex gap-6">
            {/* Left Summary Section - 30% */}
            <div className="w-[30%] space-y-4">
                <h3 className="text-md font-semibold text-[#003A71]">Summary</h3>

                <div
                    className={`p-3 rounded-lg border cursor-pointer ${selectedCategory === "All"
                        ? "border-blue-400 bg-blue-50"
                        : "border-blue-100 bg-white hover:bg-blue-50"
                        }`}
                    onClick={() => handleCategoryClick("All")}
                >
                    <div className="text-sm text-gray-600">All</div>
                </div>

                <div
                    className={`p-3 rounded-lg border cursor-pointer ${selectedCategory === "Recurring"
                        ? "border-orange-400 bg-orange-50"
                        : "border-orange-100 bg-white hover:bg-orange-50"
                        }`}
                    onClick={() => handleCategoryClick("Recurring")}
                >
                    <div className="text-sm text-gray-600">Recurring Patients</div>
                </div>

                <div
                    className={`p-3 rounded-lg border cursor-pointer ${selectedCategory === "New"
                        ? "border-blue-400 bg-blue-50"
                        : "border-blue-100 bg-white hover:bg-blue-50"
                        }`}
                    onClick={() => handleCategoryClick("New")}
                >
                    <div className="text-sm text-gray-600">New Patients</div>
                </div>

                {/* <div
                    className={`p-3 rounded-lg border cursor-pointer ${selectedCategory === "FollowUp"
                        ? "border-green-400 bg-green-50"
                        : "border-green-100 bg-white hover:bg-green-50"
                        }`}
                    onClick={() => handleCategoryClick("FollowUp")}
                >
                    <div className="text-sm text-gray-600">Total Patients</div>
                </div> */}
            </div>

            {/* Right Chart Section - 70% */}
            <div className="w-[70%]">
                <div className="flex justify-between items-center mb-4">
                    <h3 className="text-md font-semibold text-[#003A71]">Patients by Doctor</h3>

                    {/* Doctor Tabs instead of Select */}
                    <select
                        className="bg-white text-gray-600 px-4 py-2 rounded-md border border-gray-300 text-sm"
                        value={selectedDoctor}
                        onChange={(e) => setSelectedDoctor(e.target.value)}
                    >
                        <option value="">All Doctors</option>
                        {doctorList.map((doc) => (
                            <option key={doc.doctorCode} value={doc.doctorCode}>
                                {doc.fullName}
                            </option>
                        ))}
                    </select>
                </div>

                <ResponsiveContainer width="100%" height={460}>
                    <BarChart
                        data={specialityData}
                        margin={{ top: 10, right: 20, left: 0, bottom: 40 }}
                        barCategoryGap="15%"
                    >
                        <CartesianGrid vertical={false} stroke="#f0f0f0" />
                        <XAxis
                            dataKey="label"
                            axisLine={false}
                            tickLine={false}
                            tick={{ fontSize: 12, fill: "#666" }}
                        />
                        <YAxis
                            axisLine={false}
                            tickLine={false}
                            tick={{ fontSize: 12, fill: "#666" }}
                        />
                        <Tooltip
                            contentStyle={{ borderRadius: 8, fontSize: 12 }}
                            itemStyle={{ fontSize: 12 }}
                            formatter={(val) => `${val}`}
                        />
                        <Legend
                            verticalAlign="bottom"
                            height={40}
                            wrapperStyle={{
                                fontSize: 12,
                                paddingTop: 12,
                                display: "flex",
                                justifyContent: "center",
                                lineHeight: "20px",
                            }}
                        />

                        <Bar
                            dataKey={selectedCategory === "All" || selectedCategory === "Recurring" ? "recurring" : ""}
                            name="Recurring Patient"
                            fill="#ed7d31"
                            radius={[4, 4, 0, 0]}
                        />
                        <Bar
                            dataKey={selectedCategory === "All" || selectedCategory === "New" ? "new" : ""}
                            name="New Patient"
                            fill="#00b0f0"
                            radius={[4, 4, 0, 0]}
                        />
                        <Bar
                            dataKey={selectedCategory === "All" || selectedCategory === "FollowUp" ? "followUp" : ""}
                            name="Total Patient"
                            fill="#28a197"
                            radius={[4, 4, 0, 0]}
                        />
                    </BarChart>
                </ResponsiveContainer>
            </div>
        </div>
    );
};

export default PatientsBySpeciality;
